/***************************************************
██╗    ██╗██╗██████╗ ██╗ ██████╗ ██████╗ ███╗   ███╗
██║    ██║██║██╔══██╗██║██╔════╝██╔═══██╗████╗ ████║
██║ █╗ ██║██║██████╔╝██║██║     ██║   ██║██╔████╔██║
██║███╗██║██║██╔══██╗██║██║     ██║   ██║██║╚██╔╝██║
╚███╔███╔╝██║██████╔╝██║╚██████╗╚██████╔╝██║ ╚═╝ ██║
 ╚══╝╚══╝ ╚═╝╚═════╝ ╚═╝ ╚═════╝ ╚═════╝ ╚═╝     ╚═╝
***************************************************/
let styles = [
    'background: black',
    'color: white',
    'display: block',
    'line-height: 40px',
    'text-align: center',
    'fontsize: 20px',
    'font-weight: lighter'
].join(';');

console.info('%c HANDMADED WITH ❤ BY WIBICOM ', styles);

/****************************************************
* GESTION DU PUBLIC PATH DYNAMIC ;
****************************************************/
__webpack_public_path__ = (data.base.replace(/\/$/, '') + '/dist/');
console.log('Webpack Public Path:', __webpack_public_path__);

/****************************************************
* IMPORT GLOBALS DEPENDENCIES FROM NODE MODULES;
****************************************************/
window.isTouchDevice = false;

async function lazyLoadJQuery() {
  if (typeof jQuery !== "undefined") {
    window.$ = window.jQuery = jQuery;
  } else {
    const $ = await import(
      /* webpackMode: "lazy" */ /* webpackChunkName: "jquery" */ "jquery"
    );
    window.$ = window.jQuery = $.default;
  }

  // --- CHARGEMENT GLOBAL DE FANCYBOX ---
  // 1. Import du CSS
  import(/* webpackChunkName: "fancybox-css" */ "@fancyapps/fancybox/dist/jquery.fancybox.css");

  // 2. Import du JS de Fancybox (s'exécute après que jQuery soit global)
  await import(/* webpackChunkName: "fancybox" */ "@fancyapps/fancybox");

  // 3. Délégation globale : écoute les clics sur TOUT le document.
  // Fonctionne automatiquement même avec Barba.js ou du contenu injecté en AJAX.
  $(document).fancybox({
    selector: '[data-fancybox]'
  });
  // ------------------------------------

  // Suite du script
  lazyLoadInitScript();
}

// Lazy load other scripts after jQuery and Fancybox are loaded
const lazyLoadInitScript = () => {
  new Promise((resolve) => {
    import(
      /* webpackMode: "lazy" */ /* webpackChunkName: "init" */ "./init.js"
    ).then(() => {
      resolve(true);
    });
  });
};

// Call the lazy load function
lazyLoadJQuery();

let DEBUG = process.env.NODE_ENV == 'development' ? true : false;
if(!DEBUG){
    if(!window.console) window.console = {};
    var methods = ["log", "debug", "warn","info"];
    for(var i=0;i<methods.length;i++){
        console[methods[i]] = function(){};
    }
}